module.exports = "/images/ingredients-8.png";